import { render, staticRenderFns } from "./vSupplementLabelCanada.vue?vue&type=template&id=365586e7&scoped=true"
import script from "./vSupplementLabelCanada.vue?vue&type=script&lang=ts"
export * from "./vSupplementLabelCanada.vue?vue&type=script&lang=ts"
import style0 from "./vSupplementLabelCanada.vue?vue&type=style&index=0&id=365586e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365586e7",
  null
  
)

export default component.exports